import { VITE_USE_MOCK, VITE_CASE_ACTION_API, VITE_MOCK_API } from 'Constants/appEnvConstants'

export default function getServiceCaseActionBaseUrl() {
  // eslint-disable-next-line no-undef
  return JSON.parse(VITE_USE_MOCK) ? VITE_MOCK_API : VITE_CASE_ACTION_API;
}
